import React from 'react';
import VehiclesTable from './VehiclesTable';
import HeaderTable from './HeaderTable';
import GetColumns from './FormatTable';
import { LinkHome } from './Links';
import { FormatData } from './FormatExcelData'
import Loading from './loading';

function TableRenderer(props) {
  const activity = props.activity;

  const recommendationExplanation = (
    <>
      The recommendation is based on the best-scoring EV candidate in your vehicle's class with matching configurations. The EV is recommended if it achieves a high overall score.
      {props.settings?.operational_fit ? 
        <> If it only meets operational needs (passing energy, parking, and confidence scores), but has a failing economics score, the result is <i>No Change — Operational Fit</i>. If it fails to meet operational needs, the recommendation is <i>No Change</i>. </> : 
        <> If it fails any of the individual sub-scores (economics, energy, parking, or confidence), the result is <i>No Change</i>. </>}
      Please see the results page for each vehicle for additional information.
    </>
  );

  if (activity) { 
    return (
      <div>
        < HeaderTable groupName={props.groupName} multipleGroups={props.multipleGroups} dbDisplayName={props.dbDisplayName}/>
        < LinkHome addClass="table" />

        <div className={`ezev-table-wrapper`}>
          <div className="ezev-table-extra">
            <div className="ezev-table-extra-text">
              <span className="ezev-subheading table">Annual projected figures based on tracked period</span>
              <br />
              <span className="ezev-subtext ezEV-body">Click on a header to sort by that metric. Click on a vehicle to see specifics for that vehicle</span>
            </div>
            <div className="ezev-table-download-link-wrapper">
              <div className="ezev-table-download-link" onClick={()=>FormatData(activity, props.dbDisplayName, props.userSettings)}
                target="_blank"
              >
                <p className="ezev-table-download-link-text">Download</p>
              </div>
            </div>
          </div>
          {/* This table component is not set up the same as the 2 other table components. Has different styles and functionality.  */}
          <VehiclesTable columns={GetColumns(props.userSettings)} data={activity} />
          {activity && activity.length > 0 &&
            <div>
              <div className="ezev-table-footnotes ezEV-body" data-testid="noCandidatesInClassInfo-testid">
                <sup>*</sup>{recommendationExplanation}
              </div>
            </div>
          }
        </div>
      </div>
    )
  } else {
    return (
      <>
        <HeaderTable multipleGroups={false}/>
        <div className="ezev-loading-wrapper">
          <Loading/>
        </div>
      </>
    );
  }
}

export default TableRenderer;
